import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, map } from 'rxjs/operators';
import { SubscriptionState } from '~app/farp-odq/store/subscription';
import { SubscriptionQueryService } from '~app/farp-odq/store/subscription/subscription-query.service';
import { ProceedSubscriptionPayment } from '~app/farp-odq/store/subscription/subscription.actions';
import { PaymentReceipt, SelectedPremiumInfo, SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';
import { environment } from '~env';

@Component({
    selector: 'odq-registration-payment',
    templateUrl: './registration-payment.component.html',
    styleUrls: ['./registration-payment.component.scss'],
    standalone: false
})
export class RegistrationPayment {
  @Input() model: SubscriptionFormViewModel;
  @Input() loading: boolean;
  @Input() selectedPremium: SelectedPremiumInfo;
  @Input() inactiveMemberForSubscription: boolean;
  

  storeId = environment.shoppingCart.subscriptionMonerisStoreId;

  paymentError$ = this.store.select<string>(SubscriptionState.paymentError);
  paymentReceipt$ = this.store.select<PaymentReceipt>(SubscriptionState.paymentReceipt)

  isCreditCardProcessing = false;
  hidePayment = false;
  nameUnderCard : string;
  canRetry = false;

  constructor(private store: Store, private queryService: SubscriptionQueryService) {}

  ngOnInit(): void {
    this.initPayment();
  }

  private initPayment() {  
    // handling errors 
    this.paymentError$.pipe(
      filter(errorMessage => !!errorMessage),
      map(errorMesage => {
        console.log('paymentError', errorMesage);
        this.isCreditCardProcessing = false;
        this.hidePayment = true;
        this.canRetry = errorMesage.toLocaleLowerCase().indexOf('critique')<0;
      })
    ).subscribe();  
  }

  allowBypassMoneris(): boolean {
    return this.queryService.allowByPassMoneris();
  }

  doPayment($event) {
    this.isCreditCardProcessing = true;
    this.selectedPremium.setPaymentInfo($event.dataKey, this.nameUnderCard, false, false);
    this.store.dispatch(new ProceedSubscriptionPayment(this.selectedPremium));
  }

  payByCheck() {
    this.isCreditCardProcessing = true;
    this.selectedPremium.setPaymentInfo(null, null, false, true);
    this.store.dispatch(new ProceedSubscriptionPayment(this.selectedPremium));
  }
 
  retryPayment() {
    this.hidePayment = false;
  }

}